import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { sr } from '../locales/sr';
import { en } from '../locales/en';

export const useLanguage = () => {
    const context = useContext(LanguageContext);

    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }

    const { language, toggleLanguage } = context;
    const translations = language === 'sr' ? sr : en;

    return { language, toggleLanguage, t: translations };
};
